import React from "react";
import { Chip } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useThemeSettings } from "../../../../../../../theme/ThemeSettingsProvider";

const useStyles = makeStyles()((theme) => ({
  active: {
    backgroundColor: "#E8F5E9",
    color: "#1B5E20",
    "& .MuiChip-icon": {
      color: "#1B5E20",
    },
  },
  inactive: {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.action.disabled,
    "& .MuiChip-icon": {
      color: theme.palette.action.disabled,
    },
  },
  indoramaMonochrome: {
    color: "#CFE7E8",
    background: "rgba(35,224,210,0.08)",
    "& .MuiChip-icon": {
      color: "#6CF2E6",
    },
  },
}));

export const accountStatus = {
  active: { label: "Active" },
  inactive: { label: "Inactive" },
};

function AccountStatusChip({ status }) {
  const { mode } = useThemeSettings();
  const isDarkMode = mode === "dark";
  const { classes } = useStyles();

  return (
    <Chip
      label={accountStatus[status]?.label}
      className={isDarkMode ? classes.indoramaMonochrome : classes[status]}
    />
  );
}

export default AccountStatusChip;
